import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import ToolSearchpageForm from '@components/search/forms/ToolSearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'

import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import dbConnect from 'db/dbConnect'
import listToolAds from 'db/repo/listAds/listAdsTool'
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'
import makeSearchToolLinks from '@components/frontpage/functions/makeSearchToolLinks'
import substituteSearchQuery from '@pages/search/functions/substituteSearchQuery'

const DEFAULT_HEADINGS = {
    h1: 'Wyposażenie serwisów samochodowych',
    h2: 'Szukasz wyposażenia do serwisu samochodowego ? Sprawdź ofertę narzędzi warsztatowych na dostawczaki.pl'
}

export default function ToolSearchpage ({
    cubeLinks,
    query, offers, pagination,
    seo, locationObjectLd }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile)

    return (
        <Layout>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/narzedzia-warsztatowe-wyposazenie"
                buy={false}
                category="Narzędzia warsztatowe"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={264}
                src="/backgrounds/narzedzia-warsztatowe-i-wyposazenie-serwisu-warsztatowego.webp"
                alt="Narzędzia warsztatowe, wyposażenie serwisu samochodowego"
                z={7}>

                <ToolSearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    below: seoArticleBody,
                    offers,
                    pagination, }} />
            </ViewContextProvider>

            <FrontpageLinks sections={cubeLinks} />

            <FAQ qa={seo.faqFile} page="tool_searchpage" />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listToolAds(query, { cookies })
    return {
        props: {
            cubeLinks: await makeSearchToolLinks(query, '/narzedzia-warsztatowe-wyposazenie'),
            query,
            offers: ads,
            pagination,
            seo: await useUrlSeo({
                baseUrl: '/narzedzia-warsztatowe-wyposazenie',
                resolvedUrl: context.resolvedUrl,
                query,
                substituteQuery: substituteSearchQuery(query),
            }),
            locationObjectLd: locationLdSchema(query.lokalizacja),
        }
    }
}